import React from 'react';
import Modal from '@material-ui/core/Modal';
import { Button } from 'aha-components';
import { useTranslation } from 'react-i18next';

import { ReactComponent as CloseIcon } from '@/assets/icons/close.svg';

import styles from './modal.module.less';

interface Props {
  children: any;
  width?: number;
  title?: string | React.ReactNode;
  isShowHeader?: boolean;
  isShowFooter?: boolean;
  visible: boolean;
  submitDisabled?: boolean;
  isLoading?: boolean;
  className?: string;
  handleClose?: () => void;
  handleSubmit?: () => void;
  okText?: string;
  // cancelText?: string;
  keepMounted?: boolean;
  canClose?: boolean;
  style?: React.CSSProperties;
  modalStyle?: React.CSSProperties;
  isShowBack?: boolean;
  handleBack?: () => void;
  disablePortal?: boolean;
}

const WebModal: React.FC<Props> = ({
  children,
  title,
  visible,
  width = 624,
  isShowHeader = true,
  isShowFooter = true,
  submitDisabled,
  isLoading,
  className,
  handleClose,
  handleSubmit,
  okText,
  // cancelText = 'Cancel',
  keepMounted = false,
  canClose = false,
  style = {},
  modalStyle = {},
  isShowBack = false,
  disablePortal = true,
  handleBack = () => {}
}) => {
  const { t } = useTranslation();
  okText = okText || t('common.modal.submit_btn', { defaultValue: 'Submit' });

  return (
    <Modal
      aria-labelledby="spring-modal-title"
      aria-describedby="spring-modal-description"
      open={visible}
      onClose={canClose && handleClose ? handleClose : undefined}
      keepMounted={keepMounted}
      disableAutoFocus
      disableEnforceFocus
      disableRestoreFocus
      disablePortal={disablePortal}
      style={modalStyle}
    >
      <div
        className={`bg-white relative rounded-[16px] left-1/2 top-1/2 translate-x-[-50%] translate-y-[-50%] flex flex-col justify-center items-center ${styles.modalContainer} ${className}`}
        style={{ width: width + 'px', ...style }}
      >
        {isShowHeader && (
          <div className={styles.modalHead}>
            <div className={styles.title}>{title}</div>
            <div className={styles.close} onClick={handleClose}>
              <CloseIcon />
            </div>
          </div>
        )}
        {children}
        {isShowFooter && (
          <div className={styles.footer}>
            <Button className="min-w-[160px] !h-[38px]" onClick={handleClose}>
              {t('common.modal.cancel_btn', { defaultValue: 'Cancel' })}
            </Button>
            {isShowBack && (
              <Button className="min-w-[160px] !h-[38px]" onClick={handleBack}>
                {t('common.modal.back_btn')}
              </Button>
            )}
            <Button
              disabled={submitDisabled || isLoading}
              type="primary"
              loading={isLoading}
              onClick={handleSubmit}
              className="min-w-[160px] !h-[38px]"
            >
              {okText ? (
                okText
              ) : (
                <span>
                  {isLoading
                    ? t('common.modal.submitting_btn', {
                        defaultValue: 'Submitting'
                      })
                    : t('common.modal.submit_btn', { defaultValue: 'Submit' })}
                </span>
              )}
            </Button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default WebModal;
